module.exports = __webpack_public_path__ + "static/iso-grid-ec26c4e16a5f2c360aa94d5ef69de71b.gif";